ga('create', 'UA-96048692-1', 'auto');
ga('set', 'forceSSL', true);
ga('set', 'anonymizeIp', true);
ga('send', 'pageview');
